import style from 'styled-components';

export default style.span`
  text-align: center;
`;
